module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Neuigkeiten.21d7af55.jpg";